<template>
  <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.1857 13.6113L9.96689 20.8302L2.74805 13.6113" stroke="currentColor" stroke-width="1.5" />
    <path d="M0.814453 1H9.9665V20.8294" stroke="currentColor" stroke-width="1.5" />
  </svg>
</template>
